import React from 'react';
import { PrefetchPageLinks } from 'react-router';

import { hasBrowserSession } from '@utils';

import './landing.css';
import LandingReveal from './LandingReveal';
import {
  McpSection,
  HeroSection,
  NotesSection,
  StocksSection,
  LandingFooter,
  LandingHeader,
  MetricsSection,
  ExpensesSection,
  AnonymousCtaSection,
  CalendarViewsSection,
} from './sections';

const LandingPage = () => {
  const [hasSession, setHasSession] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    let isCurrent = true;

    void hasBrowserSession().then((nextHasSession) => {
      if (isCurrent) {
        setHasSession(nextHasSession);
      }
    });

    return () => {
      isCurrent = false;
    };
  }, []);

  return (
    <>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>Habitrack — habit tracking down to the last detail</title>
      <meta
        name="description"
        content="A calendar-first habit tracker with month, week, and day views. Log habits, scope notes to any period, measure with custom metrics, keep stock of the items habits consume, and track what every habit costs. Try it anonymously in one click."
      />
      <link rel="canonical" href="https://www.habitrack.io/" />
      <meta content="website" property="og:type" />
      <meta property="og:url" content="https://www.habitrack.io/" />
      <meta
        property="og:title"
        content="Habitrack — habit tracking down to the last detail"
      />
      <meta
        property="og:description"
        content="Calendar-based habit tracking with custom metrics, stock keeping, expense tracking, scoped notes, and a built-in MCP server for AI assistants. Log in anonymously to look around."
      />
      <meta
        property="og:image"
        content="https://www.habitrack.io/android-chrome-512x512.png"
      />
      <meta content="summary" name="twitter:card" />
      <meta
        name="twitter:title"
        content="Habitrack — habit tracking down to the last detail"
      />
      <meta
        name="twitter:description"
        content="Calendar-based habit tracking with custom metrics, stock keeping, expense tracking, scoped notes, and a built-in MCP server for AI assistants."
      />
      {/*<script type="application/ld+json">*/}
      {/*  {*/}
      {/*    "@context": "https://schema.org",*/}
      {/*    "@type": "SoftwareApplication",*/}
      {/*    "name": "Habitrack",*/}
      {/*    "url": "https://www.habitrack.io/",*/}
      {/*    "applicationCategory": "LifestyleApplication",*/}
      {/*    "operatingSystem": "Web",*/}
      {/*    "description": "A calendar-first habit tracker with custom metrics, stock keeping, per-habit expense tracking, scoped notes, and a built-in MCP server for AI assistants.",*/}
      {/*    "offers": {*/}
      {/*      "@type": "Offer",*/}
      {/*      "price": "0",*/}
      {/*      "priceCurrency": "USD"*/}
      {/*    }*/}
      {/*  }*/}
      {/*</script>*/}
      {hasSession && <PrefetchPageLinks page="/calendar/month" />}
      <div className="bg-background text-foreground min-h-screen antialiased">
        <LandingHeader hasSession={hasSession} />
        <main>
          <HeroSection hasSession={hasSession} />
          <CalendarViewsSection />
          <NotesSection />
          <MetricsSection />
          <StocksSection />
          <ExpensesSection />
          <McpSection />
          {hasSession === false && (
            <LandingReveal>
              <AnonymousCtaSection />
            </LandingReveal>
          )}
        </main>
        <LandingFooter hasSession={hasSession} />
      </div>
    </>
  );
};

export default LandingPage;
